import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'THROUGHPUT_ERROR';
export const LOADING = 'THROUGHPUT_LOADING';
export const SUCCESS = 'THROUGHPUT_SUCCESS';
export const SUCCESS_BREAKDOWN = 'THROUGHPUT_SUCCESS_BREAKDOWN';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data: data
  };
}

function successBreakdown(data) {
  return {
    type: SUCCESS_BREAKDOWN,
    data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const { chart, allCustomFields, excludeWeekends, workStart, workEnd, holidays, dates, trc } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : trc;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, trc.enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let tData = await worker.Throughput({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        blockedTime: filters.blockedTime,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        color: true,
        timeUnit: trc.timeUnit,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        selectedDate: trc.selectedDate
      });
      dispatch(success(tData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getBreakdownData(throughputData) {
  return async (dispatch, getState) => {
    try {
      const { selected } = getState().dashboards;
      const { data } = getState().app;

      const service = new CalculationsWorker();
      let worker = service.wrap();
      worker = await new worker(selected, data);
      const breakdownData = await worker.GetThroughputBreakdownData(throughputData);
      dispatch(successBreakdown(breakdownData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
